<template>
  <div class="contai_h">
    <!-- 数据看板 -->
    <div class="conbox">
      <div class="cont_bos">
        <div class="con_but">
          <el-date-picker
            v-model="dvalue"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </div>
        <div class="con_but">
          <el-input
            class="inps"
            placeholder="请输入当户票号"
            prefix-icon="el-icon-search"
            v-model="inpnum"
            clearable
          >
          </el-input>
          <el-button type="primary" icon="el-icon-search" @click="numsearch"
            >搜索</el-button
          >
        </div>
      </div>

      <div class="cont_box">
        <!-- //@click="toDays" -->
        <div class="cont_o">
          <h2>{{ today }}：{{ daylength }}</h2>
          <!-- <h4>今日回收：{{ dayleng }}</h4> -->
        </div>
        <div class="cont_o">
          <h2>{{ bustitle }}：{{ Total }}</h2>
          <!-- <h4>回收业务：{{ Tota }}</h4> -->
        </div>
        <div class="cont_o">
          <h2>{{ prititle }}：{{ price + "元" }}</h2>
          <!-- <h4>回收金额：{{ pric }}</h4> -->
        </div>
      </div>
    </div>

    <!-- 内容tabs -->
    <el-tabs type="border-card" v-model="activeName" @tab-click="hClick($event)">
      <!-- 待确认的订单 -->
      <el-tab-pane label="绝当待确认" name="first">
        <!-- 内容主体 -->
        <div class="cont_cont">
          <el-table :data="items" border style="width: 100%" max-height="730">
            <el-table-column
              label="编号"
              type="index"
              :index="indexMethod"
              width="80"
            ></el-table-column>
            <el-table-column prop="deta" label="建档日期" width="180"> </el-table-column>
            <el-table-column prop="ticketnumber" label="票号" width="150">
              <template slot-scope="scope">
                {{ scope.row.ticketnumber || scope.row.input_pnum }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="当户姓名" width="100">
              <template slot-scope="scope">
                {{ scope.row.name || scope.row.input_names }}
              </template>
            </el-table-column>
            <el-table-column prop="telnumber" label="电话" width="150">
              <template slot-scope="scope">
                {{ scope.row.telnumber || scope.row.input_tels }}
              </template>
            </el-table-column>
            <el-table-column prop="objname" label="当物名称" width="170">
              <template slot-scope="scope">
                {{ scope.row.objname || scope.row.input_wus }}
              </template>
            </el-table-column>
            <el-table-column prop="number" label="数量" width="100">
              <template slot-scope="scope">
                {{ scope.row.number || scope.row.tabs_inps }}
              </template>
            </el-table-column>
            <el-table-column prop="weight" label="重量/g" width="100">
              <template slot-scope="scope">
                {{ scope.row.weight || scope.row.tabs_ins }}
              </template>
            </el-table-column>
            <el-table-column prop="price" label="典当金额" width="120">
              <template slot-scope="scope">
                {{ scope.row.price || scope.row.tabs_is }}
              </template>
            </el-table-column>
            <el-table-column
              prop="startdate"
              label="典当开始日"
              width="120"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.startdate || "/" }}
              </template>
            </el-table-column>
            <el-table-column prop="enddate" label="典当结束日" width="120">
              <template slot-scope="scope">
                {{ scope.row.enddate || "/" }}
              </template>
            </el-table-column>

            <el-table-column prop="mode" label="支付方式" width="100">
              <template slot-scope="scope">
                {{ scope.row.mode || "现金" }}
              </template>
            </el-table-column>
            <el-table-column prop="cost" label="典当综合费" width="120">
              <template slot-scope="scope">
                {{ scope.row.cost || "/" }}
              </template>
            </el-table-column>
            <el-table-column prop="days" label="典当天数" width="100">
              <template slot-scope="scope">
                {{ scope.row.days || "/" }}
              </template>
            </el-table-column>
            <el-table-column label="典当状态" width="100">
              <template slot-scope="scope">
                <h3>{{ scope.row.input_names == undefined ? "绝当" : "回收物品" }}</h3>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="160">
              <template slot-scope="scope">
                <el-button
                  v-if="!scope.row.input_names"
                  @click="handleClick(scope.row._id)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
                <el-button
                  v-if="!scope.row.input_names"
                  @click="wexClick(scope.row.cardnumber, scope.row)"
                  type="text"
                  size="small"
                  >微信通知</el-button
                >
                <el-button @click="jueClick(scope.row._id)" type="text" size="small"
                  >确定绝当</el-button
                >
                <el-button @click="recoverClick(scope.row)" type="text" size="small"
                  >申请恢复业务</el-button
                >
                <el-button @click="LookClick(scope.row)" type="text" size="small"
                  >查看绝当确认书</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <!-- 确定绝当弹窗 -->
      <el-dialog
        title="绝当操作:"
        :visible.sync="dialogJue"
        width="60%"
        :before-close="handleClose"
      >
        <el-form :model="form">
          <el-form-item label="当户姓名：" :label-width="formLabelWidth">
            {{ xudata.name || xudata.input_names }}
          </el-form-item>
          <el-form-item label="当票编号：" :label-width="formLabelWidth">
            {{ xudata.ticketnumber || xudata.input_pnum }}
          </el-form-item>
          <el-form-item label="典当状态：" :label-width="formLabelWidth">
            绝当待确认
          </el-form-item>
          <el-form-item label="到期日期：" :label-width="formLabelWidth">
            {{ xudata.enddate || "/" }}
          </el-form-item>
          <el-form-item label="绝当操作人：" :label-width="formLabelWidth">
            {{ this.name }}
          </el-form-item>
          <el-form-item
            label="操作日期："
            :label-width="formLabelWidth"
            v-if="xudata.name"
          >
            <el-date-picker
              v-model="datevalue"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="dialogVisible">确 定 提 交</el-button>
        </span>
      </el-dialog>

      <!-- 已确认的订单 -->
      <el-tab-pane label="已绝当业务" name="second">
        <!-- 内容主体 -->
        <div class="cont_cont" v-if="isRouterAlive">
          <el-table
            :data="enddata"
            border
            style="width: 100%"
            max-height="730"
            :summary-method="getSummaries"
            show-summary
            v-loading="loading"
            element-loading-text="数据正在从火星赶来中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <el-table-column
              label="编号"
              type="index"
              :index="indexMethod"
              width="50"
            ></el-table-column>
            <el-table-column prop="deta" label="建档日期" width="140"> </el-table-column>
            <el-table-column prop="ticketnumber" label="票号" width="110">
              <template slot-scope="scope">
                {{ scope.row.ticketnumber || scope.row.input_pnum }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="当户姓名" width="90">
              <template slot-scope="scope">
                {{ scope.row.name || scope.row.input_names }}
              </template>
            </el-table-column>
            <el-table-column prop="telnumber" label="电话" width="140">
              <template slot-scope="scope">
                {{ scope.row.telnumber || scope.row.input_tels }}
              </template>
            </el-table-column>
            <el-table-column prop="objname" label="当物名称" width="170">
              <template slot-scope="scope">
                {{ scope.row.objname || scope.row.input_wus }}
              </template>
            </el-table-column>
            <el-table-column prop="number" label="数量" width="50">
              <template slot-scope="scope">
                {{ scope.row.number || scope.row.tabs_inps }}
              </template>
            </el-table-column>
            <el-table-column prop="weight" label="重量/g" width="100">
              <template slot-scope="scope">
                {{ scope.row.weight || scope.row.tabs_ins }}
              </template>
            </el-table-column>
            <el-table-column prop="price" label="典当金额" width="120">
              <template slot-scope="scope">
                {{ scope.row.price || scope.row.tabs_is }}
              </template>
            </el-table-column>
            <el-table-column prop="startdate" label="典当开始日" width="120">
              <template slot-scope="scope">
                {{ scope.row.startdate || "/" }}
              </template>
            </el-table-column>
            <el-table-column prop="enddate" label="典当结束日" width="120">
              <template slot-scope="scope">
                {{ scope.row.enddate || "/" }}
              </template>
            </el-table-column>
            <el-table-column prop="mode" label="支付方式" width="100">
              <template slot-scope="scope">
                {{ scope.row.mode || "现金" }}
              </template>
            </el-table-column>
            <el-table-column prop="cost" label="典当综合费" width="120">
              <template slot-scope="scope">
                {{ scope.row.cost || "/" }}
              </template>
            </el-table-column>
            <el-table-column prop="days" label="典当天数" width="100">
              <template slot-scope="scope">
                {{ scope.row.days || "/" }}
              </template>
            </el-table-column>
            <el-table-column prop="state" label="典当状态" width="100">
              <template slot-scope="scope">
                <h3>{{ scope.row.input_names == undefined ? "绝当" : "回收物品" }}</h3>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.name"
                  @click="handleClick(scope.row._id)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
                <el-button @click="LookClick(scope.row)" type="text" size="small"
                  >查看绝当确认书</el-button
                >

                <el-button
                  v-if="!scope.row.wareh"
                  @click="qxClick(scope.row._id, !!scope.row.name, scope.row)"
                  type="text"
                  size="small"
                  class="ck"
                  >选择去向</el-button
                >

                <img v-if="scope.row.wareh" class="ycl_img" src="@/assets/ycl.png" />
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <!-- <div class="pagin">
            <el-pagination
            background
            layout="prev, pager, next"
            :total=this.Total
            >
          </el-pagination>
          </div> -->

          <!-- 绝当去向弹窗 -->
          <el-dialog
            title="选择绝当去向"
            :visible.sync="diaqx"
            width="20%"
            :before-close="qxClose"
          >
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ command }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="抛售">抛售</el-dropdown-item>
                <el-dropdown-item command="恒明">恒明</el-dropdown-item>
                <el-dropdown-item command="其他">其他</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="czr">操作人:{{ this.name }}</span>
            <span class="czr">操作日期：{{ this.deta }}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="qxClose">取 消</el-button>
              <el-button type="primary" @click="qdtj">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </el-tab-pane>

      <!-- 财务确认去向 -->
      <el-tab-pane label="绝当/出库去向" name="test">
        <div>
          <el-table :data="jdata" border style="width: 100%">
            <el-table-column prop="deta" label="日期" width="180"> </el-table-column>
            <el-table-column prop="ticketnumber" label="票号"> </el-table-column>
            <el-table-column prop="name" label="姓名"> </el-table-column>
            <el-table-column prop="telnumber" label="电话"> </el-table-column>
            <el-table-column prop="objname" label="当物名称" width="180">
            </el-table-column>
            <el-table-column prop="number" label="数量"> </el-table-column>
            <el-table-column prop="weight" label="重量"> </el-table-column>
            <el-table-column prop="price" label="典当/回收金额"> </el-table-column>
            <el-table-column prop="state" label="物品状态"> </el-table-column>
            <el-table-column prop="wply" label="物品来源"> </el-table-column>
            <el-table-column prop="qx" label="物品去向"> </el-table-column>
            <el-table-column prop="czr" label="操作人"> </el-table-column>
            <el-table-column prop="czdeta" label="处理日期"> </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 申请恢复业务 -->
    <el-dialog
      title="申请恢复业务"
      :visible.sync="dialogRecover"
      width="40%"
      :before-close="RecoverDataClose"
    >
      <div class="recover">
        <span>当户姓名：{{ RecoverData.name }}</span>
        <span>票号:{{ RecoverData.ticketnumber }}</span>
        <span>业务状态：绝当待确认</span>
        <span>原到期日期：{{ RecoverData.enddate }}</span>
        <span>典当金额:{{ RecoverData.price + "元" }}</span>
        <span
          >选择当期：
          <el-button-group>
            <el-button type="primary" @click="Update(25)">25天</el-button>
            <el-button type="primary" @click="Update(30)">30天</el-button>
          </el-button-group>
        </span>
        <span>已选当期:{{ RecoverDay + "天" }}</span>

        <span>新到期日期:{{ RecoverDate }}</span>
        <span>
          典当综合费：
          <input type="text" v-model="RecoverPrice.price" />
        </span>
        <span>
          典当利息：
          <input type="text" v-model="RecoverPrice.lx" />
        </span>
        <span> 操作申请人：{{ name }} </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="RecoverDataClose">取 消</el-button>
        <el-button type="primary" @click="dialogRecoverData">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 查看绝当确认书 -->

    <el-dialog
      title="绝当确认书"
      :visible.sync="dialogLookMsg"
      width="50%"
      :before-close="LookMsgClose"
    >
      <LookMsg v-if="dialogLookMsg" :LookData="LookData" />
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="LookMsgClose">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>

    <div class="derive">
      <download-excel
        class="export-excel-wrapper"
        :data="enddata"
        :fields="json_fields"
        :name="'绝当数据.xls'"
        v-if="enddata.length !== 0"
      >
        <el-button type="primary" plain>导出表格</el-button>
      </download-excel>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs"; //引入日期处理插件
import LookMsg from "@/components/lookMsg/LookMsg.vue";
export default {
  //局部刷新测试
  provide() {
    return {
      reload: this.reload,
    };
  },

  name: "offline",
  components: {
    LookMsg,
  },
  data() {
    return {
      ACCESS_TOKEN: "", //ACCESS_TOKEN
      deta: "", //拿到今天的日期
      day: "", //计算出逾期绝当的日期
      items: [], //所有绝当的数据
      enddata: [], //已绝当的数据

      price: 0, //绝当总金额
      pric: 0, //回收总金额
      inpname: "", //搜索框的名字
      inpnum: "", //搜索框的票号
      xudata: "", //被点击的数据

      dialogFormVisible: false, //续当弹窗默认关闭
      dialogRecover: false, //申请恢复业务弹窗

      form: {
        pris: 0, //续当费用
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      formLabelWidth: "150px",
      xdate: "", //续当后的总典当天数
      datevalue: "", //选择的续当日期
      name: "", //当前登录的账户名字
      token: "", //token
      xzdate: 0, //点击选择续当的天数默认为0
      ydays: 0, //被点击的数据原来的天数，默认为0
      ypris: 0, //被点击的数据原来的综合费，默认为0
      zonpri: 0, //计算后的总综合费用
      id: "", //被点击的id

      activeName: "first",

      //绝当订单数
      Total: 0,
      //回收总数量
      Tota: 0,
      //今日绝当数量
      daylength: 0,
      //今日回收数量
      dayleng: 0,
      //总的数据页数
      fyTotal: 1,

      //选择的日期范围
      dvalue: "",

      dialogJue: false, //确定绝当弹窗默认关闭
      diaqx: false, //绝当去向弹窗
      command: "选择去向", //选择的去向值
      qid: "", //点击选择的id
      types: "", //点击绝当去向判断的类型回收/绝当

      isRouterAlive: true, //局部刷新开关

      edata: "", //被绝当去向点击的全部数据

      jdata: [], //绝当的数据

      prititle: "", //数据栏金额
      bustitle: "", //数据栏业务数量
      today: "今日绝当", //数据栏今日业务

      testArray: [],

      RecoverData: {},
      //申请恢复的业务数据
      RecoverDay: 0, //选择的当期
      RecoverDate: "", //

      RecoverPrice: {
        price: 0,
        lx: 0,
      },

      dialogLookMsg: false, //查看绝当确认书
      loading: true, //loading
      LookData: {}, //查看绝当的数据

      json_fields: {
        建档日期: "deta",
        票号: "ticketnumber",
        当户姓名: "name",
        物品名称: "objname",
        数量: "number",
        "典当金额/元": "price",
        "重量/g": "weight",
        开始日期: "startdate",
        到期日期: "enddate",
        经办人: "agent",
        复核: "review",
        财务: "finance",
      },
    };
  },
  // 事件函数
  methods: {
    //计算总金额
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            // const value = Number(curr);
            if (index === 8 || index === 12) {
              return prev + curr;
            } else {
              return (sums[index] = "N/A");
            }
          }, 0);
          sums[index] += " 元";
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },

    handleClick(e) {
      const id = e;
      this.$router.push({ path: "/details", query: { id: id } });
    },

    //点击日期搜索
    search() {
      this.loading = true;
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("add_data").where({state:"绝当",enddate:_.gte("${dayjs(
            this.dvalue[0]
          )
            .subtract("5", "day")
            .format("YYYY-MM-DD")}").and(_.lte("${dayjs(this.dvalue[1])
            .subtract("5", "day")
            .format("YYYY-MM-DD")}"))}).limit(1000).get()`,
        })
        .then((rname) => {
          rname.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.enddata = rname.data.data.reverse();
          this.loading = false;
        });
    },

    //点击票号搜索
    numsearch() {
      this.loading = true;
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").where({state:"绝当",ticketnumber:"' +
            this.inpnum +
            '"}).limit(1000).get()',
        })
        .then((rnum) => {
          rnum.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.enddata = rnum.data.data.reverse();
          this.loading = false;
        });
    },

    //绝当后添加典当记录
    sover(e, deta) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("add_data").doc("${e}").get()`,
        })
        .then((ref) => {
          ref.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          this.axios
            .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("yxus_record").add({data:{name:"${
                ref.data.data[0].name
              }",xuday:"${deta}",itemname:"${ref.data.data[0].objname}",ticketnumber:"${
                ref.data.data[0].ticketnumber
              }",
          telnumber:"${ref.data.data[0].telnumber}",startdate:"${
                ref.data.data[0].startdate
              }",xupri:"0",enddate:"${ref.data.data[0].enddate}",dday:"0",xuname:"${
                this.name
              }",overdate:"${
                ref.data.data[0].startdate
              }",ytdy:"0",pena:"0",rece:"0",stas:"绝当",pri:"${
                ref.data.data[0].price
              }",lx:"0",time:"${dayjs().format("HH:mm")}",cardnumber:"${
                ref.data.data[0].cardnumber
              }",agent:"${ref.data.data[0].agent}",review:"${
                ref.data.data[0].review
              }",finance:"",weight:"${ref.data.data[0].weight}"}})`,
            })
            .then((rs) => {
              if (rs.data.errcode == 0) {
                setTimeout(() => {
                  this.$router.go(0);
                }, 1500);
              }
            });
        });
    },

    //点击筛选出今天绝当的订单
    // toDays() {
    //   // this.items = this.dayju;
    //   // console.log('666')
    // },

    //点击确定绝当
    jueClick(e) {
      this.dialogJue = !this.dialogJue;
      return this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("add_data").doc('${e}').get()`,
        })
        .then((re) => {
          re.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.xudata = re.data.data[0];
        });
    },
    // 待确认的业务
    qdClick() {
      this.prititle = "待确认金额";
      this.bustitle = "待确认业务";
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("add_data").where({state:"在当",enddate:_.lt("' +
            this.day +
            '"),whether:true}).limit(1000).get()',
        })
        .then((re) => {
          //绝当的数据
          re.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.Total = re.data.pager.Total; //绝当待确认业务数量
          this.items = re.data.data; //绝当待确认的数据

          //筛选出今天绝当的订单
          let objdata = re.data.data.filter(
            (ele) =>
              ele.enddate == dayjs(this.day).subtract(1, "day").format("YYYY-MM-DD")
          );
          this.daylength = objdata.length;

          //循环计算出绝当的总金额
          let str = "";
          for (let i in re.data.data) {
            str += re.data.data[i].price;
            str += "+";
          }
          str = str.substring(0, str.length - 1);
          this.price = eval(str) || 0;
        });
    },

    // 点击关闭页面
    handleClose() {
      this.dialogJue = false;
      this.xudata = "";
    },

    dialogVisible() {
      this.$confirm("确认要绝当该业务吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //如果是绝当业务
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:
                'db.collection("add_data").doc("' +
                this.xudata._id +
                '").update({data:{state:"绝当"}})',
            })
            .then((tr) => {
              if (tr.data.errcode == 0) {
                return (
                  this.sover(this.xudata._id, this.datevalue),
                  this.$message({
                    type: "success",
                    message: "该业务已绝当!",
                  }),
                  setTimeout(() => {
                    this.$router.go(0);
                  }, 1000)
                );
              }
            });
          // }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消绝当",
          });
        });
    },

    //已经确认的业务
    endClick() {
      this.prititle = "已绝当金额";
      this.bustitle = "已绝当业务";
      // 请求绝当的数据
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("add_data").where({state:"绝当"}).limit(1000).get()',
        })
        .then((rda) => {
          rda.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.loading = false;
          //已确认典当订单数
          this.Total = rda.data.pager.Total;

          //已绝当业务数据
          this.enddata = rda.data.data.reverse();

          //已确认典当金额
          let str = "";
          for (let i in rda.data.data) {
            str += rda.data.data[i].price;
            str += "+";
          }
          str = str.substring(0, str.length - 1);
          this.price = eval(str) || 0;
        });
    },

    //请求回收数据方法
    getHdatas(num) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("take_back").where({whether:true,review:_.neq("")}).skip(${
            num * 1000
          }).limit(1000).get()`,
        })
        .then((rq) => {
          rq.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          return rq.data.data;
        });
    },

    //请求回收的业务
    // getRecycle(){
    //   this.today = "今日回收"
    //    this.prititle = "回收金额";
    //     this.bustitle = "回收业务"

    //    this.axios
    //         .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
    //           env: `${this.userData.env}`,
    //           query:
    //             'db.collection("take_back").where({whether:true,review:_.neq("")}).limit(1000).get()',
    //         })
    //         .then((rq) => {
    //           rq.data.data.forEach((element, index, array) => {
    //             array[index] = JSON.parse(element);
    //           });

    //           //以建当时间排列，
    //           let sdate = rq.data.data.sort(function (a, b) {
    //             return Date.parse(b.deta) - Date.parse(a.deta); // 时间倒序
    //           });
    //           this.hsdata = sdate

    //              //已确认典当订单数
    //           this.Total = rq.data.pager.Total;

    //             //回收业务的金额
    //           let sts = "";
    //           for (let b in rq.data.data) {
    //             sts += rq.data.data[b].tabs_is;
    //             sts += "+";
    //           }
    //           sts = sts.substring(0, sts.length - 1);
    //           this.price = eval(sts);

    //           // //筛选出今天回收的订单
    //           // let objdata = rq.data.data.filter(
    //           //   (ele) =>
    //           //     ele.reviewdate == dayjs().format("YYYY-MM-DD")
    //           // );
    //           // this.daylength = objdata.length;

    //         })

    //         //请求今日新增回收订单的数量
    //          this.axios
    //         .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
    //           env: `${this.userData.env}`,
    //           query:
    //             `db.collection("take_back").where({reviewdate:_.eq("${dayjs().format("YYYY-MM-DD")}")}).limit(1000).get()`,
    //         })
    //         .then(rq => {
    //           rq.data.data.forEach((element, index, array) => {
    //             array[index] = JSON.parse(element);
    //           });
    //            this.daylength = rq.data.data.length
    //           })
    // },

    //tab点击事件
    hClick(e) {
      if (e.name == "first") {
        this.qdClick();
      } else if (e.name == "second") {
        this.endClick();
      } else {
        this.getJd();
      }
    },

    //编号取反
    indexMethod(index) {
      return index + 1;
    },

    //发微信通知
    wexClick(e, datas) {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("user2020zl").where({idcard:"${e}"}).get()`,
        })
        .then((ruser) => {
          ruser.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          if (ruser.data.data[0] == undefined) {
            this.$alert(
              "该当户的业务没有绑定微信，请提醒该当户关注公众号，并填写个人信息",
              {
                confirmButtonText: "确定",
              }
            );
          } else {
            // console.log(datas)
            this.axios
              .post(
                "/api/cgi-bin/message/wxopen/template/uniform_send?access_token=" +
                  this.ACCESS_TOKEN,
                {
                  touser: ruser.data.data[0]._openid,
                  mp_template_msg: {
                    appid: "wx9019ccce538953c5",
                    template_id: "FQfChOduVO9Q-Sfvcl5F2kn3lj_AE3zE7Og1RAdeGx8",
                    url: "http://weixin.qq.com",
                    miniprogram: {
                      appid: "wx153c354afba9df6f",
                      pagepath: "pages/offline/offlines/index",
                    },
                    data: {
                      first: {
                        value: `尊敬的${datas.name}先生/女士，您以下的典当业务已绝当`,
                        color: "#173177",
                      },
                      keyword1: {
                        value: datas.ticketnumber,
                        color: "#173177",
                      },
                      keyword2: {
                        value: datas.objname,
                        color: "#173177",
                      },
                      keyword3: {
                        value: datas.startdate,
                        color: "#173177",
                      },
                      keyword4: {
                        value: datas.enddate,
                        color: "#173177",
                      },
                      keyword5: {
                        value: "绝当",
                        color: "#173177",
                      },
                      remark: {
                        value:
                          "因您逾期超5天未续当又未赎当视为绝当，典当行按《典当管理办法》、估价协议折价变卖方式处置绝当物。",
                        color: "#173177",
                      },
                    },
                  },
                }
              )
              .then(() => {
                this.$notify({
                  title: "发送成功",
                  message: "微信通知发送成功",
                  type: "success",
                });
              });
          }
        });
    },
    //恢复业务
    recoverClick(event) {
      this.RecoverData = event;
      this.dialogRecover = !this.dialogRecover;
    },
    //关闭恢复业务窗口
    RecoverDataClose() {
      this.dialogRecover = false;
      this.RecoverData = {};
      this.RecoverDate = "";
    },
    //选择恢复业务的事件
    Update(event) {
      this.RecoverDay = event;
      this.RecoverDate = dayjs(this.RecoverData.enddate)
        .add(event, "day")
        .format("YYYY-MM-DD");
    },
    //确定恢复业务事件
    dialogRecoverData() {
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("recoverData").add({data:{
            CreateDate:"${dayjs().format("YYYY-MM-DD HH:mm:ss")}",
            TicketNumber:"${this.RecoverData.ticketnumber}",
            xuDate:"${this.RecoverDate}",
            xuday:"${this.RecoverDay}",
            xupri:"${this.RecoverPrice.price}",
            xulx:"${this.RecoverPrice.lx}",
            xuname:"${this.name}",
            Isreview:false,
            username:"${this.RecoverData.name}",
            itemname:"${this.RecoverData.objname}",
            weight:"${this.RecoverData.weight}",
            overdate:"${dayjs(this.RecoverData.enddate)
              .add(1, "day")
              .format("YYYY-MM-DD")}",
            price:"${this.RecoverData.price}",
            yuDate:"${dayjs().diff(this.RecoverData.enddate, "day")}",
            pena:"0",
            uid:"${this.RecoverData._id}",
            reviewNane:""

          }})`,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.$notify({
              title: "申请已发送",
              message: "该业务已向管理员发出审核申请，请等待",
              type: "success",
            });

            this.sendContex(
              this.name,
              dayjs().format("YYYY-MM-DD HH:mm:ss"),
              this.RecoverData.name,
              this.RecoverData.ticketnumber,
              this.RecoverData.enddate
            );

            setTimeout(() => {
              this.RecoverDataClose();
            }, 1000);
          }
        });
    },
    //发送微信模板消息提醒
    sendContex(name, date, username, pNumber, enddate) {
      this.axios.post(
        "/api/cgi-bin/message/wxopen/template/uniform_send?access_token=" +
          this.ACCESS_TOKEN,
        {
          touser: "ot6pe5UKeXz0gtSlOV1YothNNqQQ", //ot6pe5cMagF59URlzBimGw0OVm9k  ot6pe5UKeXz0gtSlOV1YothNNqQQ
          mp_template_msg: {
            appid: "wx9019ccce538953c5",
            template_id: "a2UyeDFOJopn32ebyFtLPTeDdR8FkECjlXhkLJ47-sc",

            data: {
              first: {
                value: `${name}发起了待绝当业务恢复申请`,
                color: "#173177",
              },
              keyword1: {
                value: "待绝当业务恢复申请",
                color: "#173177",
              },
              keyword2: {
                value: date,
                color: "#173177",
              },
              keyword3: {
                value: `当户-${username}`,
                color: "#173177",
              },

              remark: {
                value: `票号：${pNumber},到期日期:${enddate},截至今日逾期 ${dayjs().diff(
                  enddate,
                  "day"
                )} 天，申请恢复业务，请前往后台进行复核确认`,
                color: "#173177",
              },
            },
          },
        }
      );
    },

    //绝当去向
    qxClick(eid, type, edata) {
      this.edata = edata;
      this.types = type;
      this.qid = eid;
      this.diaqx = !this.diaqx;
    },
    //绝当去向选择
    handleCommand(command) {
      this.command = command;
    },
    //取消去向
    qxClose() {
      (this.command = "选择去向"),
        (this.diaqx = false),
        (this.qid = ""),
        (this.types = ""),
        (this.edata = "");
    },
    //提交绝当去向
    qdtj() {
      //如果是绝当业务
      if (this.types == true) {
        this.axios
          .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("add_data").doc("${this.qid}").update({data:{wareh:true}})`,
          })
          .then((rj) => {
            if (rj.data.errcode == 0) {
              this.$message({
                type: "success",
                message: "该业务处理完成!",
              });
              this.reload();

              this.addjDcl();
            } else {
              this.$message.error("提交失败，请刷新页面在试");
            }
          });
      } else {
        //回收业务提交
        this.axios
          .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query: `db.collection("take_back").doc("${this.qid}").update({data:{wareh:true}})`,
          })
          .then((rh) => {
            if (rh.data.errcode == 0) {
              this.$message({
                type: "success",
                message: "该业务处理完成!",
              });
              this.reload();
              this.addhScl();
            } else {
              this.$message.error("提交失败，请刷新页面在试");
            }
          });
      }
    },
    //局部刷新
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    //添加绝当处理记录
    addjDcl() {
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("add_jdcl").add({data:{deta:"${this.edata.deta}",ticketnumber:"${this.edata.ticketnumber}",name:"${this.edata.name}",telnumber:"${this.edata.telnumber}",objname:"${this.edata.objname}",number:"${this.edata.number}",weight:"${this.edata.weight}",price:"${this.edata.price}",state:"绝当已处理",qx:"${this.command}",czr:"${this.name}",czdeta:"${this.deta}",wply:"典当转绝当"}})`,
        })
        .then((succ) => {
          if (succ.data.errcode == 0) {
            this.qxClose();
          }
        });
    },
    //添加回收处理记录
    addhScl() {
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("add_jdcl").add({data:{deta:"${this.edata.deta}",ticketnumber:"${this.edata.input_pnum}",name:"${this.edata.input_names}",telnumber:"${this.edata.input_tels}",objname:"${this.edata.input_wus}",number:"${this.edata.tabs_inps}",weight:"${this.edata.tabs_ins}",price:"${this.edata.tabs_is}",state:"绝当已处理",qx:"${this.command}",czr:"${this.name}",czdeta:"${this.deta}",wply:"回收"}})`,
        })
        .then((succ) => {
          if (succ.data.errcode == 0) {
            this.qxClose();
          }
        });
    },

    //请求绝当去向的数据
    getJd() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("add_jdcl").where({}).limit(1000).get()',
        })
        .then((jd) => {
          jd.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.jdata = jd.data.data;
          //  this.Total = jd.data.pager.Total;
          //   //已经确认的回收业务的数量
          //   this.Tota = jd.data.pager.Total;
        });
    },
    //查看绝当处理
    LookClick(event) {
      this.dialogLookMsg = !this.dialogLookMsg;
      this.LookData = event;
    },
    //关闭绝当弹窗
    LookMsgClose() {
      this.dialogLookMsg = false;
      this.LookData = {};
    },
  },
  //生命周期函数，监听组件创建时
  created() {
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN"); //获取到this.ACCESS_TOKEN
    //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();

    //今天的日期
    this.deta = dayjs().format("YYYY-MM-DD");

    //逾期、绝当鉴定日期
    this.day = dayjs().subtract(5, "day").format("YYYY-MM-DD");
  },
  //生命周期函数，监听组件挂载时
  mounted() {
    setTimeout(() => {
      this.qdClick(), (this.name = this.userData.username);
    }, 800);
  },
};
</script>
<style scoped>
.conbox {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 15px 0;
}
.cont_box {
  width: 50%;
  height: 180px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.cont_bos {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  width: 49%;
  height: 180px;
  background-color: #ffffff;
}
.cont_o {
  width: 28%;
  height: 120px;
  background-color: #d65b5b;
  border-radius: 10px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* margin: 0 30px; */
}
.cont_o h2 {
  margin: 0 0;
}
.cont_cont {
  width: 100%;
  /* height: 500px; */
  background-color: #ffffff;
  margin: 20px auto;
}
.con_but {
  width: 40%;
  display: flex;
  flex-direction: row;
}
.cont_input {
  width: 34%;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.ck {
  margin: 0 10px;
}
.czr {
  margin: 0 20px;
}
.ycl_img {
  width: 40px;
  height: 40px;
  margin: 0 10px;
}
.pagin {
  margin: 15px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.recover {
  display: flex;
  flex-direction: column;
}
.recover span {
  margin: 10px 0;
}
.derive {
  width: 50px;
  margin: 10px 0;
}
</style>
